module.exports = __webpack_public_path__ + "static/block7-ddda2c4f3073ef21e16f7bf73185a904.jpg";